import config from './config.js';
import mqttClient from './mqttClient.js';
import Log from './log.js';
import moment from 'moment';

class Mqtt {
	static client		= null;
	static callbacks    = {};
	static inited		= false;
	static projectId	= '';
	
	static init(pid, success){
		if(this.inited && pid == this.projectId){
			return success && success();
		}
		
		if(this.client){
			if(pid!=this.projectId){
				this.subscribe(pid);
				this.projectId = pid;
			} 
			
			return success && success();
		} 
		
		let token = dyEditor.getToken();
		
		if(!token) return;
		
		this.projectId = pid;
		this.clientId = token + '_' + new Date().getTime();
		//this.typeArr = ['login_msg','project_msg','resource_msg','model_msg','pano_msg'];
		
		if(this.client) return this;

		this.client = new mqttClient.Client(config.mqtt, this.clientId);
		
		//收到消息
		this.client.onMessageArrived = (res)=>{
			// console.log('mqtt',res);
			let data = JSON.parse(res.payloadString);
			if(!data.type) return;
			//console.log('mqtt onMessage:',res);
			let time = moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss');
			let type = {
				'dym'			: '模型%s',
				'depth'			: '深度图%s',
				'obj'			: 'OBJ文件%s',
				'pano'			: '全景图文件%s',
				'ply'			: '点云文件%s',
				'zip'			: 'ZIP文件%s',
				'logout'		: '用户未登录',
				'decompress'	: '解压成功.',
				'ali'			: '三维空间模型%s',
				'scan'			: '模型文件%s',
				'cpy'			: '创建体验作品%s',
				'hotspot'		: '模型热点%s',
				'pano2dyc'		: 'AI推演%s'
			}
			
			let status = {
				1 : '正在上传..',
				2 : '正在处理..',
				3 : '处理成功。',
				4 : '处理失败。',
			}
			
			let color = {
				1 : '#eee',
				2 : '#eee',
				3 : '#6c6',
				4 : '#c33'
			}
			
			let msg = type[data.type];
			if(msg){
				try {
					msg = msg.replace('%s', status[data.status]);
					
					this.callbacks[data.type] && this.callbacks[data.type].forEach(item=>{
						item(data)
					});
				} catch(e){
					console.log(e);
				}
			}
		}
		
		//连接断开
		this.client.onConnectionLost = e=>{
			//this.client = null;
			console.log('disconnected:', e.errorMessage);
		}
		
		//连接成功
		this.client.onConnected = ()=>{
			//订阅主题
			this.client.subscribe(this.projectId);	
			// console.log('mqtt connected:', this.clientId);
		}
		
		//连接mqtt服务器
		this.client.connect({
			cleanSession	: false,
			reconnect		: true, 
		});
		
		this.inited = true;
		
		success && success(this);
		
		return this;
	}
	
	//连接关闭
	static close(){
		// console.log('mqtt close:', this.client);
		this.client && this.client.disconnect();
	}
	
	static on(name, callback, replace){
		if(replace || !this.callbacks[name])
		{
			this.callbacks[name] = [callback];
		} else {
			this.callbacks[name].push(callback);
		}
	}
	
	static emit(type, data) {
		let event = {type, data, clientId:this.clientId};
		this.client.send(
			this.projectId,
			JSON.stringify(event), 
			0, 
			true);
	}

	static remove(type, callback){
		this.callbacks.hasOwnProperty(type) && delete this.callbacks[type];
	}
	
	static unload(){
		this.close();
		this.callbacks = {};		
	}
	
	//订阅
	static subscribe(projectId, success){
		this.client && this.client.subscribe(projectId);
		success && success(this);
	}
	
	//取消订阅
	static unsubscribe(projectId, success){
		this.client && this.client.unsubscribe(projectId);
		success && success(this);
	}
}

export default Mqtt;